import { render, staticRenderFns } from "./BannerIMG.vue?vue&type=template&id=7259949c&scoped=true"
import script from "./BannerIMG.vue?vue&type=script&lang=js"
export * from "./BannerIMG.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/bannerIMG.scss?vue&type=style&index=0&id=7259949c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7259949c",
  null
  
)

export default component.exports